module.exports = __webpack_public_path__ + "static/media/logo-vf-alt.49e61814.jpg";